import { AppView, VideoView, YoutubeVideoView, ButtonView, ProgressImagePathView } from "@gaming/srvg-classes-core";
import { CallToActionView } from "../CallToActionView";
import { ChunkIndicatorView } from "../ChunkIndicatorView";
import { ChunkAreaView } from "../ChunkAreaView";

/**
 * Main view class for the VFC cup view.
 */
export class MicroView extends AppView {
    chunkIndicatorView:ChunkIndicatorView;
    //videoAreaView: VideoAreaView;

    /**
     * The usual video view. Starts inactive in this view.
     */
    videoView: VideoView;
    chunkAreaView:ChunkAreaView;
    callToActionView: CallToActionView;

    /**
     * A view that encapsulates the Youtube video player, which plays a specifically designed video from our Youtube
     * channel. Saves bandwidth and server load on our streaming servers when VBL micro is not being actively used.
     */
    youtubeVideoView: YoutubeVideoView;
    /**
     * A big button that overlays the Youtube video. Clicking the button causes the Youtube video (and the button)
     * to disappear and the regular match video to start playing.
     */
    playButton: ButtonView;


    constructor(options) {
        options = options || {};
        options.name = options.name || 'cupView';
        options.selector = '#' + options.name;
        super(options);
        this.isExpanded = true;


        this.chunkIndicatorView = this.addSubView(new ChunkIndicatorView({useChunkModelDb: true}));


        //this.videoAreaView = this.addSubView( new VideoAreaView( {} ) );

        var hdChannel = null;
        if (srvg.videooptions.alt_videobasename) {
            if (!srvg.featuresInstances.getStartWithHd()) {
                hdChannel = srvg.videooptions.serverurl + srvg.videooptions.videobasename;
            }
            else {
                hdChannel = srvg.videooptions.serverurl + srvg.videooptions.alt_videobasename;
            }
        }

        // Setting the videoHandlers order for the videoView
        var videoHandlers = [];
        if (srvg.Player.getWorkingStreamType() == 'flash') {
            videoHandlers = ['flash', 'hls', 'html5'];
        } else {
            if(srvg.featuresInstances.getFlashVideoByDefault() === false)
                videoHandlers = ['hls', 'flash', 'html5'];
        }


        var myAllowFullscreen =  srvg.featuresInstances.getDisableFullscreen() ? false : true;
        var myMuted =  (srvg.featuresInstances.getDisableAudioByDefault() || srvg.videooptions.startMute) == true ? false : true;





        this.videoView = this.addSubView(new VideoView({
            selector: '#videoView',
            playerOptions: {
                useLiveplayer: false,
                debug: false,   // remove this when in production
                autoplay: false,
                disabled: true,  // disable gui elements, player.js hides
                volume: 1.0,
                poster: srvg.url.image + 'video/poster.png',
                muted: myMuted,
                fullscreen: myAllowFullscreen,
                bgcolor: '#000',
                clip: {
                    sources: [
                        {
                            type: srvg.featuresInstances.getFlashVideoByDefault() ? "video/flv" : "application/x-mpegURL",
                            src: srvg.videooptions.serverurl + srvg.videooptions.videobasename + srvg.videooptions.defaultchannel
                        },
                    ],
                    live: true,
                },
                gui: false,
                micro: true,
            }

        },srvg));



        this.chunkAreaView = this.addSubView(new ChunkAreaView({
            chunkPickerView: true,
            useChunkModelDb: true,
            callToActionViewOptions:{
                progressView: new ProgressImagePathView({
                    selector: '#progressView',
                    overwriteSizes: {
                        width: 91,
                        height: 50
                    },
                    background: srvg.url.image+'micro/cta-clock-gradient.png',
                    pathwidth: 6,
                    path: [
                        { x: 45, y:9 }, { x: 70, y:9 }, { x: 80, y:25 }, { x: 70, y:39 }, { x: 9, y:39 }, { x: 9, y:9 },
                        { x: 45, y:9 }
                    ]
                })
            }
        }));


        var disableYoutubeVideo = srvg.featuresInstances.getDisableYoutubeVideo() || typeof srvg.videooptions.youtubeId === typeof undefined || ! srvg.videooptions.youtubeId;
        if( disableYoutubeVideo ) {
            $('#youtubevideo_container').addClass('disabled');
            this.youtubeVideoView = this.addSubView( new YoutubeVideoView( {} ) );
        }
        else {
            this.youtubeVideoView = this.addSubView( new YoutubeVideoView( { selector:'#youtubevideo_container', videoId: srvg.videooptions.youtubeId } ) );
        }
        this.playButton = this.addSubView( new ButtonView( { selector: '#playbutton' } ) );


        $('#statisticsButton').click(function() {

            // get home team id and away team id
            var homeId = app.timeline.currentChunkModel.chunk.matches[app.timeline.currentChannel].homeClubId;
            var awayId = app.timeline.currentChunkModel.chunk.matches[app.timeline.currentChannel].awayClubId;

            // get id of the currently running cup
            var currentCompetitionId = app.timeline.currentCompetitionModel.competition.id;

            app.customerIntegrationController.openStatisticHead2head(homeId, awayId, currentCompetitionId);
        });
    }

    // hide all elements that would still be shown after other elements are already enabled
    handleTimeoutEvent( event, provider ) {
        $('#statisticsButton').css('display','none');
        $('.text_container_wrapper').css('display','none');
    }
}
